/**
 * @generated SignedSource<<3f593008181884aeb6d9e5498b0e2391>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type DashboardUserTargetGroupQuery$variables = {
  studentId: string;
  targetGroupId: string;
};
export type DashboardUserTargetGroupQuery$data = {
  readonly skillStatesByStudentId: ReadonlyArray<{
    readonly createdOn: any;
    readonly id: string;
    readonly inProgress: boolean;
    readonly modifiedOn: any | null | undefined;
    readonly readinessScore: any | null | undefined;
    readonly skill: {
      readonly code: string | null | undefined;
      readonly difficulty: any;
      readonly id: string;
      readonly name: string | null | undefined;
    } | null | undefined;
    readonly skillAssessment: {
      readonly isComplete: boolean;
      readonly score: number;
    } | null | undefined;
    readonly skillSubstate: {
      readonly id: string;
      readonly name: string | null | undefined;
      readonly skillState: {
        readonly id: string;
        readonly name: string | null | undefined;
      } | null | undefined;
    } | null | undefined;
  }>;
};
export type DashboardUserTargetGroupQuery = {
  response: DashboardUserTargetGroupQuery$data;
  variables: DashboardUserTargetGroupQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "studentId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "targetGroupId"
  }
],
v1 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "targetGroupId",
        "variableName": "targetGroupId"
      }
    ],
    "kind": "ObjectValue",
    "name": "filter"
  },
  {
    "kind": "Literal",
    "name": "order",
    "value": [
      {
        "id": "ASC"
      }
    ]
  },
  {
    "kind": "Variable",
    "name": "studentId",
    "variableName": "studentId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "inProgress",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "readinessScore",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "modifiedOn",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdOn",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "score",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isComplete",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "concreteType": "SkillSubstateNode",
  "kind": "LinkedField",
  "name": "skillSubstate",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    (v9/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "SkillStateNode",
      "kind": "LinkedField",
      "name": "skillState",
      "plural": false,
      "selections": [
        (v2/*: any*/),
        (v9/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "concreteType": "SkillNode",
  "kind": "LinkedField",
  "name": "skill",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "code",
      "storageKey": null
    },
    (v9/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "difficulty",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DashboardUserTargetGroupQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "StudentSkillNode",
        "kind": "LinkedField",
        "name": "skillStatesByStudentId",
        "plural": true,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "StudentSkillAssessmentNode",
            "kind": "LinkedField",
            "name": "skillAssessment",
            "plural": false,
            "selections": [
              (v7/*: any*/),
              (v8/*: any*/)
            ],
            "storageKey": null
          },
          (v10/*: any*/),
          (v11/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DashboardUserTargetGroupQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "StudentSkillNode",
        "kind": "LinkedField",
        "name": "skillStatesByStudentId",
        "plural": true,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "StudentSkillAssessmentNode",
            "kind": "LinkedField",
            "name": "skillAssessment",
            "plural": false,
            "selections": [
              (v7/*: any*/),
              (v8/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          (v10/*: any*/),
          (v11/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "f081a9fbcb3d2d601bcb53f3753b9e74",
    "id": null,
    "metadata": {},
    "name": "DashboardUserTargetGroupQuery",
    "operationKind": "query",
    "text": "query DashboardUserTargetGroupQuery(\n  $studentId: ID!\n  $targetGroupId: ID!\n) {\n  skillStatesByStudentId(studentId: $studentId, filter: {targetGroupId: $targetGroupId}, order: [{id: ASC}]) {\n    id\n    inProgress\n    readinessScore\n    modifiedOn\n    createdOn\n    skillAssessment {\n      score\n      isComplete\n      id\n    }\n    skillSubstate {\n      id\n      name\n      skillState {\n        id\n        name\n      }\n    }\n    skill {\n      id\n      code\n      name\n      difficulty\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "1267297e8b46af78aab6742e1db78652";

export default node;
